<button class="action" [disabled]="readonly" (click)="onSave()" [ngClass]="{'saving':saving}">
    <ng-content *ngIf="!saving"></ng-content>
</button>